import { render, staticRenderFns } from "./DemoShowModal.vue?vue&type=template&id=637b367d&scoped=true"
import script from "./DemoShowModal.vue?vue&type=script&lang=ts"
export * from "./DemoShowModal.vue?vue&type=script&lang=ts"
import style0 from "./DemoShowModal.vue?vue&type=style&index=0&id=637b367d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b367d",
  null
  
)

export default component.exports